//components\IncomingOrders\helpers\actions.js
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import { Box } from "@mui/material";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

// const NoActionIcon = () => (
//   <Box sx={{ position: "relative", display: "inline-flex" }}>
//     <BoltOutlinedIcon fontSize="small" />
//     <BlockOutlinedIcon
//       fontSize="small"
//       sx={{
//         position: "absolute",
//         top: -4,
//         left: -4,
//         color: "error.main",
//         fontSize: 18,
//       }}
//     />
//   </Box>
// );

// const NoActionIcon = (props) => (
//   <Box
//     sx={{
//       position: "relative",
//       display: "inline-flex",
//       alignItems: "center",
//       justifyContent: "center",
//     }}
//   >
//     <BoltOutlinedIcon {...props} />

//     <Box
//       sx={{
//         position: "absolute",
//         width: "140%",
//         height: "2px",
//         backgroundColor: "currentColor",
//         transform: "rotate(-35deg)",
//       }}
//     />
//   </Box>
// );

const NoActionIcon = ({ fontSize = "small", ...props }) => (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "text.disabled",
      transition: "opacity 0.2s ease",
      "&:hover": {
        opacity: 0.8,
      },
    }}
  >
    <BoltOutlinedIcon fontSize={fontSize} {...props} />

    <Box
      sx={{
        position: "absolute",
        width: "120%",
        height: "1.5px",
        backgroundColor: "currentColor",
        transform: "rotate(-32deg)",
        borderRadius: "2px",
        opacity: 0.9,
        pointerEvents: "none",
      }}
    />
  </Box>
);

export const ACTIONS = {
  NONE: {
    label: "Ingen åtgärd",
    doneLabel: "Ingen åtgärd utförd",
    icon: NoActionIcon,
  },
  SEND_ORDER_CONFIRMATION: {
    label: "Skicka orderbekräftelse",
    doneLabel: "Skickade orderbekräftelse",
    icon: FactCheckOutlinedIcon,
  },
  SEND_DELIVERY_CONFIRMATION: {
    label: "Skicka leveransbekräftelse",
    doneLabel: "Skickade leveransbekräftelse",
    icon: LocalShippingOutlinedIcon,
  },
};

export const getActionDoneMessages = (actions = []) => {
  return actions
    .map((a) => ACTIONS[a]?.doneLabel)
    .filter(Boolean);
};

//export const ACTION_TYPES = Object.keys(ACTION_LABELS);